import React from "react";
import { LoadingOutlined } from '@ant-design/icons';

const CircularProgress = ({className}) => <div className={`loader ${className}`}>
  {/* <img className="loader-img" src={loader} alt="loader"/> */}
  <LoadingOutlined style={{ fontSize: '50px', color: '#038fde' }} />
</div>;
export default CircularProgress;
